<template>
  <x-page title="确认订单" :loading="loading">
    <template v-if="!loading">
      <!-- 收货地址 -->
      <div
        v-if="!is全是虚拟商品"
        v-track="{
          name: '确认订单-选择地址',
          id: 'a9541ce6-206f-42d1-9415-d7f2c8b9fac0',
        }"
        :class="_.address"
      >
        <x-card
          v-if="!address.id"
          :class="_.add"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/地址.png')" :class="_.icon" />
          <div :class="_.text">请添加收货地址</div>
        </x-card>
        <x-card
          v-else
          :class="_.content"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/已选择地址.png')" :class="_.icon" />
          <div :class="_.left">
            <div :class="_.hd">
              <div :class="_.user">{{ address.receiver }}</div>
              <div :class="_.phone">{{ address.phoneNo }}</div>
              <div v-if="address.defaultFlag" :class="_.tag">默认</div>
            </div>
            <div :class="_.bd">
              {{
                `${address.province}${address.city}${address.county}${address.detail}`
              }}
            </div>
          </div>
          <van-icon name="arrow" :class="_.arrow" />
        </x-card>
      </div>

      <!-- 商品列表 -->
      <x-card
        v-for="merchant in preOrderData.orderInfo"
        :key="merchant.merchantId"
        :class="_.merchant"
      >
        <div :class="[_.hd, _._hairlineBottom]">
          <img :src="merchant.commodityInfo[0].commodityPic" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.top">
              <div :class="[_.name, _._ellipsis2]">
                {{ merchant.commodityInfo[0].commodityName }}
              </div>
              <div :class="_.count">x{{ merchant.commodityInfo[0].count }}</div>
            </div>
            <div :class="_.bottom">
              ￥{{ merchant.commodityInfo[0].totalPrice }}
            </div>
          </div>
        </div>
        <div :class="_.bd">
          <div :class="_.caption">组合内包含商品</div>
          <div
            v-for="(item, index) in merchant.commodityInfo[0]
              .jointCommodityList"
            :key="index"
            :class="_.goods"
          >
            <img :src="item.childCommodityPic" :class="_.cover" />
            <div :class="_.content">
              <div :class="_.top">
                <div :class="[_.name, _._ellipsis2]">
                  {{ item.commodityTitle }}
                </div>
                <div :class="_.count">x{{ item.num }}</div>
              </div>
              <div :class="_.bottom">
                <div :class="_.left">
                  <div :class="_.label">配送</div>
                  <div :class="_.value">快递配送</div>
                </div>
                <div :class="_.right">
                  {{
                    postFeeMap[item.childSkuId] &&
                    postFeeMap[item.childSkuId].postFee
                      ? `¥${postFeeMap[item.childSkuId].postFee}`
                      : '包邮'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="[_.ft, _._hairlineTop]">
          <div :class="_.item">
            <div :class="_.label">备注</div>
            <div :class="_.value">
              <input
                v-model="orderData[merchant.orderId].remark"
                v-fix-keyboard
                type="text"
                :class="_.input"
                placeholder="选填，给商家留言"
                maxlength="20"
              />
            </div>
          </div>
        </div>
      </x-card>

      <!-- 拼团玩法 -->
      <x-card v-if="is拼团下单" :class="_.groupBuying">
        <div :class="[_.hd, _._hairlineBottom]">
          <div :class="_.title">
            <img :src="require('./images/拼团.png')" :class="_.icon" />
            <div :class="_.text">拼团玩法</div>
          </div>
          <div :class="_.more" @click="handleGroupBuyingRuleClick">
            详细规则
            <x-icon name="arrow" :class="_.arrow" />
          </div>
        </div>
        <div :class="_.bd">
          <img
            :src="
              preOrderData.groupType === 'NORMAL'
                ? require('./images/拼团一阶玩法.png')
                : require('./images/拼团多阶玩法.png')
            "
            :class="_.image"
          />
        </div>
      </x-card>

      <!-- 概况 -->
      <x-card :class="_.brief">
        <div :class="_.item">
          <div :class="_.label">商品总额</div>
          <div :class="_.value">¥{{ preOrderData.orderAmount }}</div>
        </div>
        <div :class="_.item">
          <div :class="_.label">运费</div>
          <div :class="_.value">¥{{ postFee }}</div>
        </div>
        <div
          v-if="!is秒杀下单 && !is拼团下单"
          v-track="{
            name: '确认订单-优惠券',
            id: 'ab985c22-d4f4-45f4-93af-fd0a71c89d26',
          }"
          :class="_.item"
        >
          <div :class="_.label">优惠券</div>
          <x-pick-coupon
            v-model="couponData"
            :params="pickCouponParams"
            :class="_.value"
          >
            <template #default="{ noCoupon, selectedCoupon }">
              <span
                :class="noCoupon || !selectedCoupon.couponId ? _.gray : _.red"
              >
                {{
                  noCoupon
                    ? '无可用优惠券'
                    : selectedCoupon.couponId
                    ? `-¥${selectedCoupon.discountedAmt}`
                    : '选择优惠券'
                }}
              </span>
              <van-icon name="arrow" :class="_.arrow" />
            </template>
          </x-pick-coupon>
        </div>
        <div v-for="item in discountData" :key="item.name" :class="_.item">
          <div :class="_.label">{{ item.name }}</div>
          <div :class="_.value">
            <span :class="_.red"> -¥{{ item.amount }} </span>
          </div>
        </div>
      </x-card>

      <!-- 操作 -->
      <div :class="_.actions">
        <div :class="_.ft">
          <div :class="_.total">合计：￥{{ actualMoney }}</div>
          <div :class="_.grow" />
          <x-button
            v-track="{
              name: '确认订单-立即支付',
              id: '334a0312-e334-4ab4-8bf9-51ca1c0138e1',
              content: goodsIds.join('|'),
            }"
            small
            :class="_.button"
            @click="handlePayClick"
          >
            立即支付
          </x-button>
        </div>
      </div>
      <div :class="_.placeholder" />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { AddressBridge } from '@/views/address/bridge'
  import {
    apiGroupBuyingTradeCalcPostFee,
    apiGroupBuyingTradePreOrder,
    apiGroupBuyingTradeTradeOrder,
    apiTradeGeneralTradeCalcPostFee,
    apiTradeGeneralTradePreOrder,
    apiTradeGeneralTradeTradeOrder,
    apiTradeSecKillTradeSeckillCalcPostFee,
    apiTradeSecKillTradeSeckillConfirmResult,
    apiTradeSecKillTradeSeckillTradeOrder,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { flatten, keyBy, sumBy, values, wait } from 'vtils'
  import {
    getManyGoodsBonus,
    loopUntil,
    mapQuery,
    prepareData,
    submit,
    Track,
  } from '@/utils'
  import { globalModel } from '@/model'
  import { handleGoodsError } from '@/views/goods/exports'
  import { mall } from '@/mall_jssdk'
  import { navigateBack, redirectTo } from '@/router'

  const handleGoodsOrderError = handleGoodsError({
    商品下架: () => navigateBack(),
    活动结束: () => navigateBack(),
    活动不能参与: () => navigateBack(),
  })

  export default Vue.extend({
    mixins: [
      globalModel.mixin,
      mapQuery({
        type: {
          key: 'type',
        },
        _preOrderData: {
          key: 'data',
          json: true,
        },
        _preOrderRequestData: {
          key: 'preOrderRequestData',
          json: true,
        },
      }),
      Track.provideMark(() => ({
        page: '确认订单',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,

      // 收货地址
      address: {},

      // 下单数据
      orderData: {},

      // 优惠券数据
      couponData: {},

      // 邮费
      postFee: 0,

      // 邮费映射: {skuId: postFee}
      postFeeMap: {},

      // 订单 ID 的邮费
      orderIdToPostFee: {},

      // 最新的预下单数据
      lastPreOrderData: {},

      // 折扣数据
      discountData: [],
    }),

    computed: {
      // 是否拼团下单
      is拼团下单() {
        return this.type === 'groupBuying'
      },
      // 是否秒杀下单
      is秒杀下单() {
        return this.type === 'seckill'
      },
      // 预下单数据
      preOrderData() {
        return this.lastPreOrderData.preOrderId
          ? this.lastPreOrderData
          : this._preOrderData
      },
      // 预下单请求数据
      preOrderRequestData() {
        return this._preOrderRequestData
      },
      // 商品 ID 列表
      goodsIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(...merchant.commodityInfo.map(goods => goods.commodityId))
          return res
        }, [])
      },
      // 商品名称列表
      goodsNames() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(...merchant.commodityInfo.map(goods => goods.commodityName))
          return res
        }, [])
      },
      // 商品资源 ID 列表（用于查询优惠券）
      goodsResourceIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(
            ...merchant.commodityInfo.map(goods =>
              JSON.stringify({
                id: goods.resourceId,
                name: goods.commodityName,
                price: goods.unitPrice,
                count: goods.count,
                totalAmt: mall.calculator.sub(
                  goods.totalPrice,
                  goods.discountActivityAmount,
                ),
                superimposeDiscountType: this.discountData[0]?.type || null,
                categoryId: goods.categoryId,
              }),
            ),
          )
          return res
        }, [])
      },
      // 选择优惠券的参数
      pickCouponParams() {
        return {
          goodsIdList: this.goodsResourceIds,
          amt: this.preOrderData.orderAmount,
          discountedAmt: mall.calculator.add(
            ...this.discountData.map(item => item.amount),
          ),
          businessType: this.preOrderData.businessType,
          unitOrgCode: this.preOrderData.unitOrgCode,
        }
      },
      // 商品数量
      totalGoods() {
        return sumBy(
          this.preOrderData.orderInfo,
          merchant => merchant.totalQuantity,
        )
      },
      // 实付金额
      actualMoney() {
        return mall.calculator.add(
          _ =>
            _.sub(
              // 订单金额
              this.preOrderData.orderAmount,
              // 减去折扣金额
              _ => _.add(...this.discountData.map(item => item.amount)),
              // 减去优惠券金额
              this.is秒杀下单 || this.is拼团下单
                ? 0
                : this.couponData.discountedAmt || 0,
            ),
          // 加上邮费
          this.postFee,
        )
      },
      is全是虚拟商品() {
        return this.preOrderData.preOrderContentType === 2
      },
    },

    watch: {
      // 计算邮费
      address: {
        immediate: true,
        async handler(address) {
          if (!address.id) {
            this.postFee = 0
            this.lastPreOrderData = this._preOrderData
          } else {
            await submit(async $ => {
              await $.start()
              this.lastPreOrderData = await (this.is拼团下单
                ? apiGroupBuyingTradePreOrder({
                    ...this.preOrderRequestData,
                    countyCode: this.address.districtCode,
                  }).catch(handleGoodsOrderError)
                : this.is秒杀下单
                ? // 秒杀商品只预下单一次
                  Promise.resolve(this._preOrderData)
                : apiTradeGeneralTradePreOrder({
                    ...this.preOrderRequestData,
                    countyCode: this.address.districtCode,
                  })
              ).then(async res => {
                const goodsList = flatten(
                  res.orderInfo.map(orderItem => orderItem.commodityInfo),
                )
                const bonusMap = await getManyGoodsBonus(goodsList)
                for (const goods of goodsList) {
                  goods.bonusText = bonusMap[goods.skuId] || ''
                }
                return res
              })
              await wait(0)
              const { orderInfo } = await (this.is拼团下单
                ? apiGroupBuyingTradeCalcPostFee
                : this.is秒杀下单
                ? apiTradeSecKillTradeSeckillCalcPostFee
                : apiTradeGeneralTradeCalcPostFee)({
                preOrderId: this.preOrderData.preOrderId,
                consigneeAddress: {
                  province: this.address.province,
                  city: this.address.city,
                  area: this.address.county,
                  areaCode: this.address.districtCode,
                  detail: this.address.detail,
                  name: this.address.receiver,
                  phoneNo: this.address.phoneNo,
                },
              })
              this.postFee = sumBy(orderInfo, item => item.postFee || 0)
              this.postFeeMap = keyBy(
                orderInfo[0].commodityInfo[0].childOrderList,
                item => item.commodityInfo[0].skuId,
              )
              this.orderIdToPostFee = orderInfo.reduce((res, item) => {
                res[item.orderId] = item.postFee
                return res
              }, {})
            })
          }
        },
      },
      // 计算订单提交数据
      preOrderData: {
        immediate: true,
        handler(preOrderData) {
          this.orderData = preOrderData.orderInfo.reduce((res, merchant) => {
            res[merchant.orderId] = {
              orderId: merchant.orderId,
              remark: '',
            }
            return res
          }, {})
          this.discountData = preOrderData.discountItems || []
        },
      },
    },

    mounted() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData() {
        const { address } = await prepareData({
          address: AddressBridge.getDefaultAddress().then(
            res => res || {},
            () => ({}),
          ),
        })
        this.address = address
        this.loading = false
      },

      // 点击选择地址
      async handleChooseAddressClick() {
        const address = await AddressBridge.chooseAddress()
        if (address && address.id) {
          this.address = address
        }
      },

      // 点击拼团规则
      handleGroupBuyingRuleClick() {
        dcb.navigateTo({
          url: this.preOrderData.ruleUrl,
        })
      },

      // 点击立即支付按钮
      async handlePayClick() {
        await submit(async $ => {
          if (!this.is全是虚拟商品 && !this.address.id) {
            return $.fail('请先添加收货地址')
          }
          await $.start()
          let payData = await (this.is拼团下单
            ? apiGroupBuyingTradeTradeOrder
            : this.is秒杀下单
            ? apiTradeSecKillTradeSeckillTradeOrder
            : apiTradeGeneralTradeTradeOrder)({
            preOrderId: this.preOrderData.preOrderId,
            consigneeName: this.address.receiver,
            consigneeTel: this.address.phoneNo,
            consigneeAddress: {
              province: this.address.province,
              city: this.address.city,
              area: this.address.county,
              areaCode: this.address.districtCode,
              detail: this.address.detail,
              name: this.address.receiver,
              phoneNo: this.address.phoneNo,
            },
            tradeOrderInfo: values(this.orderData),
            couponId: this.couponData.couponId,
            discountAmount: this.couponData.discountedAmt || 0,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
          }).catch(handleGoodsOrderError)
          this.$track.push({
            name: '提交订单',
            id: 'TiJiaoDinDan',
            extra: {
              order_id: payData.orderId,
              order_price: this.actualMoney,
              commodity_id: this.goodsIds.join(','),
              commodity_name: this.goodsNames.join(','),
              original_price: this.preOrderData.orderAmount,
              present_price: this.actualMoney,
              discount_price: this.preOrderData.orderAmount - this.actualMoney,
              submit_type: '立即支付',
            },
          })
          if (this.is秒杀下单) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
            )
            if (res.confirmState === 2) return $.fail(res.msg)
            payData = res.result
          }
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: payData,
            })
            await wait(1000)
            redirectTo(
              this.is拼团下单 ? 'GroupBuyingPaySuccess' : 'OrderPayResult',
              {
                // 拼单 ID
                id: payData.groupOrderId,
              },
            )
          } catch {
            redirectTo(
              this.is拼团下单 ? 'GroupBuyingOrderIndex' : 'OrderIndex',
              {
                active: 1,
              },
            )
          }
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .address {
    .add {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 19px;
        height: 19px;
      }

      .text {
        margin-left: 2px;
        font-size: 14px;
        color: #222222;
      }

      &:active {
        opacity: 0.8;
      }
    }

    .content {
      display: flex;
      align-items: center;

      .icon {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
      }

      .left {
        margin-left: 12px;
        flex-grow: 1;

        .hd {
          display: flex;
          align-items: center;

          .user {
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }

          .phone {
            margin-left: 8px;
            font-size: 14px;
            color: #888888;
            line-height: 20px;
          }

          .tag {
            margin-left: 8px;
            background: #fff2f1;
            border-radius: 1000px;
            font-size: 10px;
            color: #ff111c;
            padding: 2px 5px;
            line-height: 1;
          }
        }

        .bd {
          margin-top: 4px;
          font-size: 12px;
          color: #222222;
          line-height: 16px;
        }
      }

      .arrow {
        margin-left: 24px;
        flex-shrink: 0;
        font-size: 14px;
        color: #bebebe;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .merchant {
    .hd {
      display: flex;
      align-items: stretch;
      padding-bottom: 12px;
      font-size: 0;

      .cover {
        flex-shrink: 0;
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 4px;
      }

      .content {
        flex-grow: 1;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .top {
          display: flex;

          .name {
            flex-grow: 1;
            font-size: 15px;
            font-weight: var(--bold-value);
            color: #222222;
            line-height: 18px;
          }

          .count {
            margin-left: 14px;
            flex-shrink: 0;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
          }
        }

        .bottom {
          font-size: 16px;
          font-weight: var(--bold-value);
          color: #ff111c;
          line-height: 22px;
        }
      }
    }

    .bd {
      .caption {
        margin-top: 12px;
        font-size: 14px;
        font-weight: var(--bold-value);
        color: #222222;
        line-height: 22px;
      }

      .goods {
        margin-top: 12px;
        display: flex;
        align-items: stretch;
        background: #f8f8f8;
        border-radius: 8px;
        padding: 8px;

        .cover {
          flex-shrink: 0;
          width: 66px;
          height: 66px;
          object-fit: cover;
          border-radius: 8px;
        }

        .content {
          margin-left: 12px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .top {
            display: flex;

            .name {
              flex-grow: 1;
              font-size: 14px;
              color: #333;
              line-height: 20px;
            }

            .count {
              margin-left: 14px;
              flex-shrink: 0;
              font-size: 14px;
              color: #999999;
              line-height: 20px;
            }
          }

          .bottom {
            flex-shrink: 0;
            display: flex;
            align-items: center;

            .left {
              flex-grow: 1;
              display: flex;
              align-items: center;

              .label {
                font-size: 12px;
                color: #333333;
                line-height: 17px;
              }

              .value {
                margin-left: 12px;
                font-size: 12px;
                color: #999999;
                line-height: 17px;
              }
            }

            .right {
              font-size: 14px;
              font-weight: var(--bold-value);
              color: #333333;
              line-height: 20px;
            }
          }
        }
      }
    }

    .ft {
      margin-top: 12px;
      padding-top: 12px;

      .item {
        display: flex;
        align-items: center;

        .label {
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }

        .value {
          margin-left: 12px;
          flex-grow: 1;
          font-size: 12px;
          color: #888888;

          .input {
            width: 100%;
            appearance: none;
            outline: none;
            box-shadow: none;
            border: none;
            border-radius: 0;

            &::placeholder {
              color: #bebebe;
            }
          }
        }

        .extra {
          flex-shrink: 0;
          font-size: 12px;
          color: #222222;
        }
      }
    }
  }

  .groupBuying {
    .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 12px;

      .title {
        display: flex;
        align-items: center;

        .icon {
          width: 16px;
          height: 16px;
        }

        .text {
          margin-left: 8px;
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }
      }

      .more {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #989898;
        line-height: 17px;

        .arrow {
          font-size: 14px;
          color: #999;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }

    .bd {
      padding-top: 12px;

      .image {
        width: 100%;
      }
    }
  }

  .brief {
    .item {
      display: flex;
      align-items: center;

      + .item {
        margin-top: 12px;
      }

      .label {
        flex-shrink: 0;
        font-size: 14px;
        color: #222222;
      }

      .value {
        flex-grow: 1;
        font-size: 14px;
        color: #222222;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 1;

        .gray {
          color: #999;
        }

        .red {
          color: #ff111c;
        }

        .arrow {
          margin-left: 4px;
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }
      }
    }
  }

  .actions {
    position: fixed;
    // fix: iPhone 8 下不随滑动实时更新问题
    // https://stackoverflow.com/a/49264494
    transform: translate3d(0, 0, 0);
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .ft {
      background-color: white;
      display: flex;
      align-items: center;
      padding: 8px 12px;

      .amount {
        flex-shrink: 0;
        font-size: 14px;
        color: #888888;
      }

      .total {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: bold;
        color: #ff111c;
      }

      .grow {
        flex-grow: 1;
      }

      .button {
        margin-left: 8px;
        flex-shrink: 0;
      }
    }

    + .placeholder {
      height: 120px;
    }
  }
</style>
